/** Firebase Analytics event names for consent manager (keep ≤ 40 chars for GA4). */
export const ConsentLogEvents = {
    SIG_FIELDS_EMPTY_DOC_NAME: 'consent_sig_fields_empty_doc_name',
};
